<form [formGroup]="formGroup">
    <mat-dialog-content>
        <mat-form-field subscriptSizing="dynamic">
            <mat-label>Client Reference (OccupantId)</mat-label>
            <input matInput formControlName="clientRefCtrl" required>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-stroked-button (click)="onCancel()">Cancel</button>
        <button mat-flat-button color="primary" (click)="onSave()" [disabled]="!validateForm()">Save</button>
    </mat-dialog-actions>
</form>